module.exports = __webpack_public_path__ + "img/7_192.37c2a50c.png";